module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"poLineItemStatus":{"helpBtnTitle":"Instructions","printBtnTitle":"Print Approval Document"}}}')
  delete Component.options._Ctor
}
